import Home from '@/components/pages/Home.vue';
import About from '@/components/pages/About.vue';
import Resume from '@/components/pages/Resume.vue';
import Contact from '@/components/pages/Contact.vue';
import ProjectDetail from '@/components/pages/ProjectDetail.vue';

const routes = [
  { path: '/', component: Home, alias: ['/home','/portfolio', '/projects'] },
  { path: '/portfolio/:project_code',alias:'/projects/:project_code', component: ProjectDetail},
  { path: '/resume', component: Resume},
  { path: '/about', component: About },
  { path: '/contact', component: Contact }
]

export default routes;